export default __webpack_public_path__ + "static/media/gitbook.527a274c.svg";